import {
	defaultQueryClientConfig,
	LogbookSettingsState,
	MESFMain,
} from "@dexteel/mesf-core";
import "react-datepicker/dist/react-datepicker.css";
import { createRoot } from "react-dom/client";
import "./app.css";
import "./setup/ag-grid-license";

import { AuthenticationConfig } from "./setup/auth-config";
import { customConfigurations } from "./setup/configurations";
import { CustomNavbar } from "./setup/navbar";
import { CustomRoutes } from "./setup/routes";

import { MutationCache, QueryClient } from "@tanstack/react-query";
import { enqueueSnackbar, SnackbarProvider } from "notistack";
import { NuqsAdapter } from "nuqs/adapters/react-router/v6";
import "./setup/nprogress";

const logbookSettings = {
	entry: {
		withAssetFilter: "selector" as const,
		filterAssets: "area" as const,
		allowAttachments: true,
		canEditAsset: true,
		exportToExcel: true,
		useShiftNavigatorBasedOnAsset: true,
	},
	report: {
		withAssetFilter: "selector" as const,
		filterAssets: "area" as const,
		showAttachments: true,
		showAsset: true,
		exportToExcel: true,
	},
} as Partial<LogbookSettingsState>;

const queryClient = new QueryClient({
	...defaultQueryClientConfig,
	mutationCache: new MutationCache({
		onSuccess: (_data, _variables, _context, mutation) => {
			const message = mutation.meta?.successMessage as string | undefined;
			if (message) enqueueSnackbar(message, { variant: "success" });
		},
	}),
});
const container = document.getElementById("root")!;
const root = createRoot(container);
root.render(
	<NuqsAdapter>
		<SnackbarProvider
			maxSnack={3}
			autoHideDuration={2500}
			anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
		>
			<MESFMain
				queryClient={queryClient}
				showAreaSelector={true}
				routes={CustomRoutes}
				navbarTitle={"SWV MILL"}
				navbar={CustomNavbar}
				authentication={AuthenticationConfig}
				configurations={customConfigurations}
				logbookSettings={logbookSettings}
				operatorsFeature
				emailTopicsFeature
				appReleaseApps={[
					{
						appCode: "swv-mill-app",
						label: "SWV Mill App",
						platform: "android",
					},
				]}
			/>
		</SnackbarProvider>
	</NuqsAdapter>,
);
